// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__7hGVA","range":"MonthRangeSwitch_range__14fmm","disabled":"MonthRangeSwitch_disabled__3J957"};